import { emojiPattern, getEmojiUnicodePoints } from './emoji';

export const linkify = (inputText = '') => {
  if (typeof inputText !== 'string') {
    return '';
  }

  let replacedText = inputText;

  const replacePattern1 =
    /(^|[\s :])(\b(https?|ftp):\/\/[-A-ZА-Я0-9+&@#\/%?=~_|!:,.;]*[-A-ZА-Я0-9+&@#\/%=~_|])/gim;
  replacedText = replacedText.replace(
    replacePattern1,
    '$1<a href="$2" target="_blank" rel="noopener noreferrer">$2</a>'
  );

  const replacePattern2 = /(^|[^\/^\>])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(
    replacePattern2,
    '$1<a href="http://$2" target="_blank" rel="noopener noreferrer">$2</a>'
  );

  const replacePattern3 =
    /(^|[\s :])([a-zA-ZА-Яа-я0-9\-\_\.]+\.[a-zA-ZА-Яа-я]{2,6}(\b|$))/gim;
  replacedText = replacedText.replace(
    replacePattern3,
    '$1<a href="http://$2" target="_blank" rel="noopener noreferrer">$2</a>'
  );

  const replacePattern4 =
    /([\s ])(([a-zA-Z0-9\-\_\.])+@[a-zA-Z0-9\_]+?(\.[a-zA-Z]{2,6})+)/gim;
  replacedText = replacedText.replace(
    replacePattern4,
    '$1<a href="mailto:$2">$2</a>'
  );

  const replacePattern5 = /([\s ])(\+?[0-9\-\(\)]{6,20})/gim;
  replacedText = replacedText.replace(
    replacePattern5,
    '$1<a href="tel:$2">$2</a>'
  );

  replacedText = replacedText.replace(emojiPattern, (match) => {
    const emojiPoints = getEmojiUnicodePoints(match);
    const emojiCode = emojiPoints
      .split(' ')
      .map((item) => `&#${item};`)
      .join('');
    return emojiCode;
  });

  return replacedText;
};

